import React from 'react';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '../ui/accordion';

// Accessible FAQ accordion (Radix). Answers are always rendered in the DOM for crawlers.
export const FAQAccordion = ({ faqs, testIdPrefix = 'faq' }) => (
  <Accordion type="single" collapsible className="divide-y divide-border rounded-2xl border border-border bg-white px-5 sm:px-6" data-testid={`${testIdPrefix}-accordion`}>
    {faqs.map((f, i) => (
      <AccordionItem key={f.q} value={`item-${i}`} data-testid={`${testIdPrefix}-item-${i}`} className="border-b-0">
        <AccordionTrigger className="min-h-[56px] py-4 text-start text-[16px] font-semibold text-primary hover:no-underline sm:text-[17px]">{f.q}</AccordionTrigger>
        <AccordionContent forceMount className="pb-5 text-[15px] leading-relaxed text-muted-foreground data-[state=closed]:hidden">{f.a}</AccordionContent>
      </AccordionItem>
    ))}
  </Accordion>
);
